module.exports = __webpack_public_path__ + "img/Grafico-Sellar.50764d75.png";